import {useState, useEffect} from 'react';
import Modal from '@mui/material/Modal';
import Avatar from '@mui/material/Avatar';
import { IoClose as Close } from 'react-icons/io5';
import ErrorHandler from '@Root/ErrorHandler';
import ToggleStyleSwitch from '@CommonRepresentationalDisplay/Switch/ToggleStyleSwitch';
import UserInfoService from '@Helpers/URLHelpers/UserInfoService';
import ProjectService from '@Helpers/URLHelpers/ProjectService';
import CircularProgress from '@mui/material/CircularProgress';
import FormAgentService from '@Helpers/URLHelpers/KaiziqResolve/FormAgentService';
import { MdEmail as Email, MdNotifications as Notifications } from 'react-icons/md';
import { FaWhatsapp as WhatsApp } from 'react-icons/fa';
import { MdAdd as Add, MdUpdate as Update, MdDone as Done, MdWarning as Warning } from 'react-icons/md';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './FormAgentView.scss';


export default function FormAgentView(props) {

    const [, setKaiziqResolveConnection] = useState(props.kaiziqResolveConnection);
    const [cursor, setCursor] = useState('auto');
    const [user, setUser] = useState();
    const [formAgentDetails, setFormAgentDetails] = useState({
        'settings': {
            'create': {
                'email': props.details?.settings?.create?.email,
                'whatsapp': props.details?.settings?.create?.whatsapp
            },
            'update': {
                'email': props.details?.settings?.update?.email,
                'whatsapp': props.details?.settings?.update?.whatsapp
            },
            'resolve': {
                'email': props.details?.settings?.resolve?.email,
                'whatsapp': props.details?.settings?.resolve?.whatsapp
            },
            'escalate': {
                'email': props.details?.settings?.escalate?.email,
                'whatsapp': props.details?.settings?.escalate?.whatsapp
            }
        }
    })
    const [refresh, setRefresh] = useState(false);
    const userInfoService = new UserInfoService();
    new ProjectService();
    const formAgentService = new FormAgentService();
    const errorHandler = new ErrorHandler();
    const className = 'formAgentView';
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
        '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1'];

    useEffect(() => {
        setKaiziqResolveConnection(props.kaiziqResolveConnection);
        renderData();
    }, [props])

    const renderData = async() => {
        await renderUserData();
    }

    const renderUserData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let userObj = await userInfoService.getUserById(props.formAgent.userId);
                userObj = JSON.parse(userObj.body);
                setUser(userObj);
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return true;
    }

    const handleAddFormAgent = async(e)=> {
        e?.preventDefault();
        setCursor('wait');
        try {
            let formAgentObj = props.formAgent;
            formAgentObj.details = JSON.stringify(formAgentDetails)
            formAgentObj = await formAgentService.updateFormAgent(formAgentObj);
            formAgentObj = JSON.parse(formAgentObj.body);
            props.reloadData();
            props.closePopup();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const handleCreateEmailToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.create.email = !formAgentDetailsObj?.settings?.create?.email;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleCreateWhatsAppToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.create.whatsapp = !formAgentDetailsObj?.settings?.create?.whatsapp;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleUpdateEmailToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.update.email = !formAgentDetailsObj?.settings?.update?.email;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleUpdateWhatsAppToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.update.whatsapp = !formAgentDetailsObj?.settings?.update?.whatsapp;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleResolveEmailToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.resolve.email = !formAgentDetailsObj?.settings?.resolve?.email;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleResolveWhatsAppToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.resolve.whatsapp = !formAgentDetailsObj?.settings?.resolve?.whatsapp;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleEscalateEmailToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.escalate.email = !formAgentDetailsObj?.settings?.escalate?.email;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const handleEscalateWhatsAppToggle = () => {
        let formAgentDetailsObj = formAgentDetails;
        formAgentDetailsObj.settings.escalate.whatsapp = !formAgentDetailsObj?.settings?.escalate?.whatsapp;
        setFormAgentDetails(formAgentDetailsObj);
        setRefresh(!refresh);
    }

    const getInitials = (name) => {
        if (!name) return 'NA';
        const names = name.split(' ');
        if (names.length >= 2) {
            return names[0][0] + names[names.length - 1][0];
        }
        return names[0][0];
    };

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}>
            <div className={className}>
                <div className={`${className}__modal`}>
                    {/* Header */}
                    <div className={`${className}__header`}>
                        <div className={`${className}__header__left`}>
                            {user?.photo ? (
                                <img 
                                    src={URL.createObjectURL(dataURLtoFile(user.photo))}
                                    className={`${className}__header__avatar`}
                                    alt='profile'
                                />
                            ) : (
                                <Avatar 
                                    className={`${className}__header__avatar`}
                                    sx={{ 
                                        bgcolor: colorList[user?.fullName?.charCodeAt(0) % colorList?.length] + ' !important',
                                        width: 56,
                                        height: 56
                                    }}
                                >
                                    {getInitials(user?.fullName)}
                                </Avatar>
                            )}
                            <div className={`${className}__header__text`}>
                                <h2 className={`${className}__header__title`}>{user?.fullName}</h2>
                                <p className={`${className}__header__subtitle`}>@{user?.userName}</p>
                            </div>
                        </div>
                        <button 
                            className={`${className}__header__closeBtn`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            <Close />
                        </button>
                    </div>

                    {/* Body */}
                    <div className={`${className}__body`}>
                        <div className={`${className}__section`}>
                            <label className={`${className}__section__label`}>
                                <Notifications className={`${className}__section__label__icon`} />
                                Notification Settings
                            </label>
                            <p className={`${className}__section__hint`}>
                                Configure when this agent should receive notifications
                            </p>

                            <div className={`${className}__notifications`}>
                                {/* Create Notifications */}
                                <div className={`${className}__notifications__group`}>
                                    <div className={`${className}__notifications__group__header`}>
                                        <Add className={`${className}__notifications__group__icon`} />
                                        <div className={`${className}__notifications__group__info`}>
                                            <h3 className={`${className}__notifications__group__title`}>New Submissions</h3>
                                            <p className={`${className}__notifications__group__desc`}>
                                                When new tickets are created
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`${className}__notifications__group__items`}>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <Email className={`${className}__notifications__item__icon email`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    Email Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.create?.email}
                                                onChange={handleCreateEmailToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.create}
                                            />
                                        </div>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <WhatsApp className={`${className}__notifications__item__icon whatsapp`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    WhatsApp Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.create?.whatsapp}
                                                onChange={handleCreateWhatsAppToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.create}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Update Notifications */}
                                <div className={`${className}__notifications__group`}>
                                    <div className={`${className}__notifications__group__header`}>
                                        <Update className={`${className}__notifications__group__icon`} />
                                        <div className={`${className}__notifications__group__info`}>
                                            <h3 className={`${className}__notifications__group__title`}>Ticket Updates</h3>
                                            <p className={`${className}__notifications__group__desc`}>
                                                When tickets are modified
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`${className}__notifications__group__items`}>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <Email className={`${className}__notifications__item__icon email`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    Email Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.update?.email}
                                                onChange={handleUpdateEmailToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.update}
                                            />
                                        </div>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <WhatsApp className={`${className}__notifications__item__icon whatsapp`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    WhatsApp Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.update?.whatsapp}
                                                onChange={handleUpdateWhatsAppToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.update}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Resolve Notifications */}
                                <div className={`${className}__notifications__group`}>
                                    <div className={`${className}__notifications__group__header`}>
                                        <Done className={`${className}__notifications__group__icon`} />
                                        <div className={`${className}__notifications__group__info`}>
                                            <h3 className={`${className}__notifications__group__title`}>Ticket Resolutions</h3>
                                            <p className={`${className}__notifications__group__desc`}>
                                                When tickets are resolved
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`${className}__notifications__group__items`}>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <Email className={`${className}__notifications__item__icon email`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    Email Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.resolve?.email}
                                                onChange={handleResolveEmailToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.resolve}
                                            />
                                        </div>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <WhatsApp className={`${className}__notifications__item__icon whatsapp`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    WhatsApp Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.resolve?.whatsapp}
                                                onChange={handleResolveWhatsAppToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.resolve}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Escalate Notifications */}
                                <div className={`${className}__notifications__group`}>
                                    <div className={`${className}__notifications__group__header`}>
                                        <Warning className={`${className}__notifications__group__icon`} />
                                        <div className={`${className}__notifications__group__info`}>
                                            <h3 className={`${className}__notifications__group__title`}>Ticket Escalations</h3>
                                            <p className={`${className}__notifications__group__desc`}>
                                                When tickets need attention
                                            </p>
                                        </div>
                                    </div>
                                    <div className={`${className}__notifications__group__items`}>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <Email className={`${className}__notifications__item__icon email`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    Email Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.escalate?.email}
                                                onChange={handleEscalateEmailToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.escalate}
                                            />
                                        </div>
                                        <div className={`${className}__notifications__item`}>
                                            <div className={`${className}__notifications__item__left`}>
                                                <WhatsApp className={`${className}__notifications__item__icon whatsapp`} />
                                                <span className={`${className}__notifications__item__label`}>
                                                    WhatsApp Notifications
                                                </span>
                                            </div>
                                            <ToggleStyleSwitch
                                                checked={formAgentDetails?.settings?.escalate?.whatsapp}
                                                onChange={handleEscalateWhatsAppToggle}
                                                disabled={cursor === 'wait' || !formAgentDetails?.settings?.escalate}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className={`${className}__footer`}>
                        <button
                            className={`${className}__footer__cancelBtn`}
                            onClick={props.closePopup}
                            disabled={cursor === 'wait'}
                        >
                            Cancel
                        </button>
                        <button
                            className={`${className}__footer__updateBtn`}
                            onClick={handleAddFormAgent}
                            disabled={cursor === 'wait'}
                        >
                            {cursor === 'wait' ? (
                                <CircularProgress size={20} sx={{ color: 'white' }} />
                            ) : (
                                <>
                                    <Update />
                                    Update Settings
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
